/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Crm_Move_Link_InvalidInputs */

const en_error_crm_move_link_invalid = /** @type {(inputs: Error_Crm_Move_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose brands the customer is invited to meet in this campaign.`)
};

/**
* | output |
* | --- |
* | "Choose brands the customer is invited to meet in this campaign." |
*
* @param {Error_Crm_Move_Link_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_crm_move_link_invalid = /** @type {((inputs?: Error_Crm_Move_Link_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Crm_Move_Link_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_crm_move_link_invalid(inputs)
});